// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"e25a25e7","104":"debc3a7e"}[chunkId] + ".chunk.js";
};